import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../../../UserDashboard/components/UserDashboardHome/UserDashboardHome.css";
import "../../../UserDashboard/components/StatementTable/StatementTable.css";
import localeText from "../../../../locale";
import { Toast } from "primereact/toast";
import { Column } from "primereact/column";
import { locale } from "../../../../utilities/locale/locale";
import handleLocale from "../../../../utilities/LocaleSwitch";
import { FilterMatchMode } from "primereact/api";
import AdminService from "../../../../service/AdminService";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputText } from "primereact/inputtext";
import { typeTransfer } from "../../../UserDashboard/components/WithdrawIntent/WithdrawIntent";
import { formatPrice } from "../../../../utilities/formatPrice";
import { Link, useHistory } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { fill } from "@cloudinary/url-gen/actions/resize";
import handleCurrency from "../../../../utilities/CurrencySwitch";
import UserInitialsAvatar from "../../../../components/UserInitialsAvatar/UserInitialsAvatar";

function formatDate(date) {
  date = new Date(date);

  const dd = date.getUTCDate();
  const mm = date.getUTCMonth() + 1;
  const yy = date.getUTCFullYear();

  return dd + "/" + mm + "/" + yy;
}

const ListBangood = ({ userInfo, plan }) => {
  const [loading, setLoading] = useState(false);
  const [bangoodRequests, setBangoodRequests] = useState([]);
  const [filteredBangoodRequests, setFilteredBangoodRequests] = useState([]);
  const [selectedWithdrawRequest, setSelectedWithdrawRequest] = useState("");
  const [processVisible, setProcessVisible] = useState(false);
  const [currentOrderRequest, setCurrentOrderRequest] = useState(null);
  const adminService = new AdminService();
  const toast = useRef(null);
  // const history = useHistory();
  // const urlToGo = "/purchasesdetails";
  const [retryFetch, setRetryFetch] = useState(true);

  const filters2 = {
    paypalEmailToTransfer: { value: null, matchMode: FilterMatchMode.CONTAINS },
    bankname: { value: null, matchMode: FilterMatchMode.CONTAINS },
    iban: { value: null, matchMode: FilterMatchMode.CONTAINS },
    accountOwner: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  useEffect(() => {
    if (retryFetch) {
      setRetryFetch(false);
      fetchBangoodRequests();
    }
  }, [retryFetch]);

  async function fetchBangoodRequests() {
    try {
      setLoading(true);
      const res = await adminService.getBangoodRequests(
        localStorage.getItem("__extraconomy_token")
      );

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        setLoading(false);
      } else {
        setBangoodRequests(res.result);
        setFilteredBangoodRequests(res.result);
        setLoading(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setLoading(false);
      console.log(e);
    }
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  async function processBangood(id) {
    try {
      setLoading(true);
      const res = await adminService.postProcessBangood(
        localStorage.getItem("__extraconomy_token"),
        id
      );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        setLoading(false);
      } else {
        toast.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("processOrderSuccessfully"),
          life: 6000,
        });
        setRetryFetch(true);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      console.log(e);
    }
  }

  const filterByBangoodRequests = (withdraw) => {
    if (withdraw) {
      const filteredData = bangoodRequests.filter(
        (obj) =>
          obj?.userprocess?.firstname.toLowerCase().includes(withdraw.toLowerCase()) ||
          obj?.userprocess?.surname.toLowerCase().includes(withdraw.toLowerCase()) ||
          obj?.accountOwner?.toLowerCase().includes(withdraw.toLowerCase()) ||
          obj?.bankname?.toLowerCase().includes(withdraw.toLowerCase()) ||
          obj?.iban?.toLowerCase().includes(withdraw.toLowerCase())
      );
      setFilteredBangoodRequests([...filteredData]);
    } else {
      setFilteredBangoodRequests(bangoodRequests);
    }
  };

  return (
    <div className="card border-1 border-300">
      <ConfirmDialog
        draggable={false}
        visible={processVisible}
        onHide={() => {
          setCurrentOrderRequest(null);
          setProcessVisible(false);
        }}
        message={localeText("processThisRequest")}
        header={localeText("confirmYourAction")}
        icon="pi pi-exclamation-triangle"
        accept={() => processBangood(currentOrderRequest.id)}
        reject={() => {
          setCurrentOrderRequest(null);
          setProcessVisible(false);
        }}
        acceptLabel={localeText("confirm")}
        rejectLabel={localeText("cancel")}
      />

      <Toast ref={toast} />

      <h3 className="my-4">{localeText("ordersPlacedWithBangood")}</h3>

      <p>{localeText("searchByNameSurnameUserAccountBank")}:</p>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "justify-content",
          alignItems: "center",
        }}
      >
        <InputText
          className="w-100"
          name="tracking"
          value={selectedWithdrawRequest}
          onChange={(e) => {
            setSelectedWithdrawRequest(e.target.value);
            filterByBangoodRequests(e.target.value);
          }}
          placeholder={localeText("search")}
        />
      </div>
      <hr />

      <DataTable
        className="mt-4 mb-6 p-datatable-customers"
        value={filteredBangoodRequests}
        paginator
        responsiveLayout="scroll"
        loading={loading}
        dataKey="id"
        filters={filters2}
        filterDisplay="row"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={localeText("showingFirstToLast")}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          header={localeText("buyerProfilePic")}
          style={{ width: "10%" }}
          body={(order) => {
            return (
              <>
                <UserInitialsAvatar
                  avatarUrl={order?.buyer?.urlAvatar}
                  firstName={order?.buyer?.firstname}
                  lastName={order?.buyer?.surname}
                  fullName={order?.buyer?.username}
                  className="layout-dashboard-urlavatar"
                  alt="buyer-avatar"
                />
              </>
            );
          }}
        ></Column>
        <Column
          header={localeText("sellerProfilePic")}
          style={{ width: "10%" }}
          body={(order) => {
            return (
              <>
                <UserInitialsAvatar
                  avatarUrl={order?.seller?.urlAvatar}
                  firstName={order?.seller?.firstname}
                  lastName={order?.seller?.surname}
                  fullName={order?.seller?.username}
                  className="layout-dashboard-urlavatar"
                  alt="seller-avatar"
                />
              </>
            );
          }}
        />
        <Column
          field="id"
          header={"ID"}
          style={{ width: "20%" }}
          filter
          filterPlaceholder={localeText("search")}
          filters={filters2}
          filterDisplay="row"
          sortable
        />
        <Column
          field={"buyer.username"}
          style={{ width: "20%" }}
          header={localeText("byBuyer")}
          sortable
          filter
          filterPlaceholder={localeText("searchByBuyer")}
          filters={filters2}
          filterDisplay="row"
        />
        <Column
          field={"seller.username"}
          style={{ width: "20%" }}
          header={localeText("seller")}
          sortable
          filter
          filterPlaceholder={localeText("searchBySeller")}
          filters={filters2}
          filterDisplay="row"
        />
        {/* <Column
          header={localeText("preview")}
          body={(order) => {
            return (
              <div className="flex">
                {order.itens
                  .filter((order, index) => index < 7)
                  .map((order) => {
                    return (
                      <div key={`p${order.id}`}>
                        <AdvancedImage
                          cldImg={cloudinaryInstance
                            .image(
                              order.productVariation
                                ? order.productVariation.imageid
                                : order.product.imageid1
                            )
                            .resize(fill().width(50).height(50))
                            .format("webp")}
                          style={{ outline: "1px solid #e0e0e0", outlineOffset: "4px" }}
                          className="border-round mr-3"
                          height={50}
                        />
                      </div>
                    );
                  })}
              </div>
            );
          }}
          style={{ width: "30%" }}
        /> */}
        <Column
          field="itens.length"
          header={localeText("itemsQuantity")}
          style={{ width: "10%" }}
        />

        <Column
          header={localeText("status")}
          body={(order) => {
            return (
              <>
                {order.status === "SENT" && (
                  <span
                    className="team-member-role text-0 p-1 border-round"
                    style={{ backgroundColor: "#42A5F5" }}
                  >
                    {localeText("sent").toUpperCase()}
                  </span>
                )}
                {order.status === "PAID" && (
                  <span
                    className="team-member-role text-0 p-1 border-round"
                    style={{ backgroundColor: "#F7B005" }}
                  >
                    {localeText("paid").toUpperCase()}
                  </span>
                )}
                {order.status === "RECEIVED" && (
                  <span
                    className="team-member-role text-0 p-1 border-round"
                    style={{ backgroundColor: "#46a748" }}
                  >
                    {localeText("received").toUpperCase()}
                  </span>
                )}
              </>
            );
          }}
          sortable
          field="status"
        ></Column>
        <Column
          header={localeText("date")}
          body={(order) => {
            return <p>{formatDate(new Date(order.date))}</p>;
          }}
          sortable
          field="date"
        />
        <Column
          header={localeText("actions")}
          body={(order) => {
            return (
              // <Button
              //   icon="pi pi-eye"
              //   onClick={() => {
              //     const path = `${urlToGo}/${order.id}`;
              //     history.push(path);
              //   }}
              //   className="p-button-help p-button-rounded"
              //   style={{ textSize: "4em" }}
              // />
              <>
                {order.status_order_banggood === "NOT PROCESSED" && (
                  <Button
                    label={localeText("process")}
                    icon="pi pi-check"
                    className="p-button-success p-button-rounded"
                    onClick={() => {
                      setProcessVisible(true);
                      setCurrentOrderRequest(order);
                    }}
                  />
                )}
              </>
            );
          }}
          style={{ width: "10%" }}
        />
      </DataTable>
    </div>
  );
};

export default ListBangood;
